<template>
  <div style="display: flex;">
    <ImgView :src="jobForm.img" />
    <div>
      <div>
        <el-form ref="form" :model="jobForm" label-width="120px">
          <el-form-item label="实名：" style="margin-bottom: 0;">
<!--            <span>{{jobForm.identityAuth.overallAuthState==2?jobForm.identityAuth.identityName:''}}</span>-->
            {{ jobForm.identityAuth.identityState == 2?jobForm.identityAuth.identityName:jobForm.identityAuth.zhimaState == 1?jobForm.identityAuth.zhimaCertName + ' (芝麻)':jobForm.identityAuth.baiduState == 1?jobForm.identityAuth.baiduCertName + ' (百度)':'' }}
          </el-form-item>
          <el-form-item label="行业：" style="margin-bottom: 0;">
            <span>{{jobForm.profession}}</span>
          </el-form-item>
          <el-form-item label="职能：" style="margin-bottom: 10px;">
            <span>{{jobForm.function}}</span>
          </el-form-item>
          <el-form-item label="职位：">
            <el-input type="text" v-model="jobForm.position" placeholder="用户职位名"  style="width:28em;"></el-input>
          </el-form-item>
          <el-form-item label="公司/机构：">
            <el-input type="text" v-model="jobForm.compName" placeholder="用户公司名"  style="width:28em;"></el-input>
          </el-form-item>
          <el-form-item label="审核结果：">
            <el-radio-group v-model="state">
              <el-radio-button :label="2">通过 <i class="el-icon-check" v-show="state==2"></i></el-radio-button>
              <el-radio-button :label="3">不通过 <i class="el-icon-check" v-show="state==3"></i></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="不通过原因：" v-show="state==3">
            <el-input type="textarea" v-model="jobForm.remark" placeholder="不通过原因仅用户可见" style="width:28em;margin-bottom: 8px;"></el-input>
            <el-radio-group v-model="msg" @change="msgChange">
              <el-radio :label="'请上传工牌或名片等有效材料。'">请上传工牌或名片等有效材料</el-radio>
              <el-radio :label="'身份证未认证成功。请先完善身份证资料，再上传认证材料。'">身份证未认证成功。请先完善身份证资料，再上传认证材料</el-radio>
              <el-radio :label="'该材料显示的名字，与用户实名不一致，请重新上传材料。'">该材料显示的名字，与用户实名不一致，请重新上传材料</el-radio>
              <el-radio :label="'材料过于模糊，无法审核。请重新上传清晰材料。'">材料过于模糊，无法审核。请重新上传清晰材料</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="材料类型：">
            <el-radio-group v-model="authType" style="line-height:18px;padding-top:3px;">
              <el-radio :label="0">其他材料</el-radio>
              <el-radio :label="1">名片</el-radio>
              <el-radio :label="2">在职证明</el-radio>
              <br/>
              <el-radio :label="3">工牌</el-radio>
              <el-radio :label="4">企业邮箱</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer" style="text-align: center">
        <el-button @click="cancel">返 回</el-button>
        <el-button type="primary"  @click="submit" v-loading="submitLoading">提 交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateAuthJob } from '@/api/url'
import { postFormData } from '@/api/api'
import ImgView from "@/views/auth/components/ImgView";
export default {
  name: "JobDialog",
  components: { ImgView },
  props: {
    value: Object
  },
  data() {
    return {
      jobForm: this.value.jobForm,
      authType: this.value.jobForm.authType?this.value.jobForm.authType:0,
      submitLoading: false,
      state: 2,
      msg: ''
    }
  },
  methods: {

    //返回
    cancel() {
      // this.jobForm = this.value.jobForm,
      this.$emit('close');
    },

    msgChange(){
      this.jobForm.remark = this.msg;
    },

    //提交
    submit() {
      if(this.state == 3 && !this.jobForm.remark){
        this.$message({
          showClose: true,
          duration: 1500,
          message: '不通过原因不能为空',
          type: 'warning'
        })
        return;
      }
      this.$confirm(this.state == 2?'确定要给予【'+this.jobForm.nickName+'】通过吗？':this.state == 3?'确定要给予【'+this.jobForm.nickName+'】不通过吗？':'').then(() => {
        this.submitLoading = true;
        let _this = this;
        let param = {};
        param['id'] = this.jobForm.id;
        param['userId'] = this.jobForm.userId;
        param['position'] = this.jobForm.position;
        param['compName'] = this.jobForm.compName;
        param['state'] = this.state;
        param['authType'] = this.authType;
        param['remark'] = this.state == 3?this.jobForm.remark:'';
        postFormData(updateAuthJob,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.$emit('confirm')
            _this.$emit('close');
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          _this.submitLoading = false;
        })
            .catch(function(){
              _this.submitLoading = false;
            })
      })
          .catch(() => {})
    }
  },
  watch: {

  },
  mounted() {

  },
  created() {
  }

}
</script>

<style>

</style>
